import SupportConfirmationContent from "../../../../src/pages/pricing/contact/support/support-confirmation-content.md";
import { NewsLetterBlade } from "../../../../src/components/news-letter-blade";
import { GoogleTagManager } from "../../../../src/components/retargetting";
import * as React from 'react';
export default {
  SupportConfirmationContent,
  NewsLetterBlade,
  GoogleTagManager,
  React
};